import { lazy, Suspense, useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";

const MaintenancePage = lazy(() => import("../Pages/MaintenancePage"));
const MainPage = lazy(() => import("../Pages/MainPage"));

export const AppRouter = () => {
    const [ bg, setBg ] = useState(null);

    useEffect(() => {
        if (bg === null)
            import('../Assets/svg/Beach.svg').then(img => {
                setBg(img.default)
            }).catch(err => console.log(err));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="h-full bg-gradient-to-b from-[#57CDFF] to-[#9BE1FF]">
            <div id="main" className="h-full px-2 py-10 md:py-64 bg-[#9BE1FF]" style={{
                backgroundImage: `url(${bg})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover"
            }}>
                <Suspense fallback={<div id="main" className="h-full px-2 py-10 md:py-64 bg-[#47b4e2]"></div>}>
                    <Switch>
                        <Route exact path="/">
                            { process.env.REACT_APP_MAINTENANCE === "false" ? <MainPage /> : <MaintenancePage /> }
                        </Route>
                    </Switch>
                </Suspense>
            </div>
        </div>
    )
};